"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.USER_ACTIVITY = exports.USER_STATS = exports.DAILY_FEED = exports.USER_COMPLETED_DATA = exports.REFERRALS = exports.GET_USER_SUBSCRIPTIONS = exports.USER = void 0;
const client_1 = require("@apollo/client");
const fragments_1 = require("../../fragments");
const user_1 = require("../../fragments/user");
exports.USER = (0, client_1.gql) `
  ${user_1.USER_FIELDS}
  query user($active: Boolean) {
    restricted {
      user {
        ...UserFields
      }
    }
  }
`;
exports.GET_USER_SUBSCRIPTIONS = (0, client_1.gql) `
  query userSubscriptions($active: Boolean) {
    restricted {
      user {
        subscriptions(active: $active) {
          id
          productId
          periodEndAt
          endedAt
          purchaseSource
          product {
            id
            name
            typeId
            duration
            price
            subscription
            stripePriceId
          }
        }
      }
    }
  }
`;
exports.REFERRALS = (0, client_1.gql) `
  query Referrals {
    restricted {
      user {
        id
        username
        referralCount
      }
    }
  }
`;
exports.USER_COMPLETED_DATA = (0, client_1.gql) `
  ${fragments_1.PICTURE_FIELDS}
  query CompletedQuestionCards {
    restricted {
      user {
        completedCards {
          id
          createdAt
          updatedAt
          concept {
            id
            name
          }
          lastSeen
          reviewDate
          score
          iteration
          optimalFactor
          cardId
          card {
            id
            conceptId
            concept {
              id
              name
            }
            topic {
              id
              name
            }
            question
            explanation
            pictures {
              ...PictureFields
            }
          }
        }
        completedCardsCount
      }
    }
  }
`;
exports.DAILY_FEED = (0, client_1.gql) `
  query DailyFeed {
    restricted {
      user {
        dailyFeed {
          topics {
            id
            name
            typeId
            totalCards
            totalQuestions
            dailyFeedCards
          }
          id
          marks {
            id
            score
          }
          redCards
          yellowCards
          greenCards
          dailyTask
        }
      }
    }
  }
`;
exports.USER_STATS = (0, client_1.gql) `
  query UserStats($classYear: String, $universityId: Int) {
    restricted {
      userStats(classYear: $classYear, universityId: $universityId) {
        userId
        score
        percentile
        medianScore
        medianPercentile
        meanScore
        meanPercentile
        stddevScore
        stddevPercentile
        series
      }
    }
  }
`;
exports.USER_ACTIVITY = (0, client_1.gql) `
  query UserActivity($days: Int) {
    restricted {
      userActivity(days: $days) {
        dailyProgress {
          date
          dateString
          totalCorrect
          totalCount
          totalIncorrect
          totalAttempted
          intensity
          score
        }
        avgScore
        avgAttempted
        currentStreak
        longestStreak
      }
    }
  }
`;
